import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear, faArrowRightFromBracket, faUser, faSortDown } from '@fortawesome/free-solid-svg-icons';
// import './dropDownMenu.css';

function DropDownMenu() {
    useEffect(() => {
        document.getElementById("navbarDropdownMenuLink").addEventListener('mouseover', async () => {
            document.querySelector(".dropdown-react").style.display = "flex";
        });

        document.querySelector(".dropdown-react").addEventListener('mouseleave', async () => {
            document.querySelector(".dropdown-react").style.display = "none";
        });
        
        // Optional: Close dropdown on click outside
        window.addEventListener('click', function (e) {
            // const dropdown = document.getElementById('menuDropdown');
            const dropdown = this.document.getElementById('dropdown-react');
            if (!dropdown.contains(e.target)) {
                dropdown.classList.remove('show');
            }
        });
    }, [])
    
    return(
        <ul id='dropdown-react' className="dropdown-react" aria-labelledby="navbarDropdownMenuLink" style={{marginLeft: "-2rem"}}>
            <a className='' href="/profile"><li className=''><FontAwesomeIcon icon={faUser} style={{marginRight: "5px"}}/>Profile</li></a>
            <a className='' href="/settings"><li className=''><FontAwesomeIcon icon={faGear} style={{marginRight: "5px"}}/>Setting</li></a>
            <a className='' href="/logout"><li className=''><FontAwesomeIcon icon={faArrowRightFromBracket} style={{marginRight: "5px"}}/>logout</li></a>
        </ul>
        // <div className="dropdown" id="menuDropdown">
        //     {/* <button className="dropdown-toggle" onclick={toggleDropdown}>Menu</button> */}
        //     <FontAwesomeIcon id='navbarDropdownMenuLink' icon={faSortDown}/>     
        //     <div className="dropdown-menu">
        //         <a href="#" className="dropdown-item">Home</a>
        //         <a href="#" className="dropdown-item">About</a>
        //         <a href="#" className="dropdown-item">Contact</a>
        //     </div>
        // </div>
    );
}

export default DropDownMenu;